var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({staticClass:"ui-icon-btn",class:[_vm.size === 'sm' && 'ui-icon-btn--sm', _vm.plain && 'ui-icon-btn--plain'],attrs:{"type":"button","title":_vm.title || _vm.label,"aria-label":_vm.label}},_vm.$listeners),[_c('v-icon',{attrs:{"size":_vm.iconSize}},[_vm._v(_vm._s(_vm.icon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }